import { Injectable } from '@angular/core';
import { BaseService } from '../../../../core/base/base.service';
import { HttpClient } from '@angular/common/http';
import { GenericBuildingCategoryModel } from '../../../../core/models/generic-building-category.model';
import { ObjectApiInterface } from '../../../../core/base/interfaces/object-api.interface';
import { AuthService } from '../../../../core/services/auth.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GenericBuildingCategoryService extends BaseService<GenericBuildingCategoryModel> {
  defaultSort = 'technicalIdentifier';
  defaultSortOrder = 'asc';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'generic-building-category', authService);
  }

  checkDependencies(category: GenericBuildingCategoryModel) {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/checkDependencies/${category._id}`, {});
  }

  changeAndArchiveGeneric(_id: string, body: any) {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/changeAndArchiveGeneric/${_id}`, body).pipe(
      map(x => {
        return x;
      }),
    );
  }

  getTenants(): Observable<ObjectApiInterface<any>> {
    return this.http.get<ObjectApiInterface<any>>(`${this.baseUrlApi}/tenants`);
  }

  downloadExcelTemplateWithBuildings(tenantId: string): Observable<ObjectApiInterface<any>> {
    return this.http.get<ObjectApiInterface<any>>(
      `${this.baseUrlApi}/download-excel-template-with-data?tenantId=${tenantId}`,
    );
  }

  importWithTenant(formData: FormData, tenantId: string): Observable<ObjectApiInterface<GenericBuildingCategoryModel>> {
    return this.http.post<ObjectApiInterface<GenericBuildingCategoryModel>>(
      `${this.baseUrlApi}/import?tenantId=${tenantId}`,
      formData,
      { headers: { 'Error-CRUD': 'IMPORT' } },
    );
  }
}
